import { BankDetail, Proposal } from "@/models/proposal.model";
import { axiosInstance } from "./axiosInstance";

type GetProposalsParams = {
  page: number;
  pageSize: number;
  proposalId?: string;
  name?: string;
  cpf?: string;
  sellerName?: string;
  releasedValue?: number;
  proposalDate?: string;
  paymentDate?: string;
  statuses?: string[];
  sortBy?: string;
  sortDirection?: string;
};

export const getProposals = async ({
  page,
  pageSize,
  proposalId,
  name,
  cpf,
  sellerName,
  releasedValue,
  proposalDate,
  paymentDate,
  statuses,
  sortBy,
  sortDirection,
}: GetProposalsParams): Promise<{ data: Proposal[]; totalPages: number }> => {
  try {
    const response = await axiosInstance.get<{
      status: "success" | "error";
      data: Proposal[];
      totalPages: number;
      page: number;
      pageSize: number;
    }>(`/api/proposal`, {
      params: {
        page,
        pageSize,
        proposalId,
        name,
        cpf,
        sellerName,
        releasedValue,
        proposalDate,
        paymentDate,
        statuses,
        sortBy,
        sortDirection,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const getProposalByBalanceSolicitationId = async (
  balanceSolicitationId: string
): Promise<Proposal | null> => {
  if (!balanceSolicitationId) return null;
  try {
    const proposalRes = await axiosInstance.get(
      `/api/proposal/balance-solicitation/${balanceSolicitationId}`
    );

    return proposalRes.data;
  } catch (error) {
    console.error("Erro ao obter o Proposta:", error);
    throw error;
  }
};

export const updateProposal = async (
  proposalData: Partial<Proposal>
): Promise<Proposal> => {
  proposalData = {...proposalData, origin: 'SELFSERVICE'}
  try {
    const response = await axiosInstance.put<Proposal>(
      `/api/proposal/${proposalData.id}`,
      proposalData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao criar proposta:", error);
    throw error;
  }
};

export const updateProposalBankDetail = async (
  bankDetailData: Partial<BankDetail> & { id?: string | number }
): Promise<BankDetail> => {
  try {
    const { id, ...data } = bankDetailData;

    if (!id) {
      throw new Error(
        "O ID da proposta é obrigatório para atualizar os detalhes bancários."
      );
    }

    const response = await axiosInstance.put<BankDetail>(
      `/api/proposal/${id}/bank-detail`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar detalhes bancários da proposta:", error);
    throw error;
  }
};

export const cancelProposal = async (id: string): Promise<Proposal> => {
  try {
    const response = await axiosInstance.post<Proposal>(
      `/api/proposal/${id}/cancel`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao cancelar proposta:", error);
    throw error;
  }
};


export const getLastProposalByDocumentId = async (
  document: string,
  slug: string
): Promise<Proposal | null> => {
  try {
    if (!document || !slug) {
      console.error("Documento e slug são obrigatórios");
      return null;
    }

    const proposalRes = await axiosInstance.get(
      `/api/proposal/self-service/document`,
      {
        params: {
          document,
          slug
        }
      }
    );

    return proposalRes.data;
  } catch (error) {
    console.error("Erro ao obter a Proposta:", error);
    return null;
  }
};